import React from 'react'

export default function SHGalleryFolder({ folderName, description, coverImageURL, onClick, onDelete, isAdmin }) {

    return (
        <div className='sh-gallery-folder-card' onClick={onClick}>
            <div className='sh-gallery-folder-banner'>
                {coverImageURL ? (
                    <img className='sh-gallery-folder-banner-img' src={coverImageURL} alt={folderName} />
                ) : (
                    <div className='sh-gallery-folder-banner-img' />
                )}
            </div>
            <div className='sh-gallery-folder-meta'>
                <span className='sh-gallery-folder-title'>{folderName}</span>
                {description && <span className='sh-gallery-folder-desc'>{description}</span>}
            </div>
        </div>
    )
}
